import React from 'react';
import { InfluencerHero } from '../components/influencers/InfluencerHero';
import { Marquee } from '../components/Marquee';
import { InfluencerServices } from '../components/influencers/InfluencerServices';
import { Roster } from '../components/influencers/Roster';
import { HowItWorks } from '../components/influencers/HowItWorks';
import { StatsBar } from '../components/influencers/StatsBar';
import { InfluencerCTA } from '../components/influencers/InfluencerCTA';
export function InfluencersPage() {
  return <>
      <InfluencerHero data-id="element-293" data-mp="2bq2ndzp0ockk" />
      <Marquee items={['BRAND DEVELOPMENT', 'CONTENT', 'REPRESENTATION', 'PARTNERSHIPS']} data-id="element-294" data-mp="2bpayt8tu7f3s" />
      <InfluencerServices data-id="element-295" data-mp="2kpzee7yvpnis" />
      <Roster data-id="element-296" data-mp="2krai67sbqv9w" />
      <HowItWorks data-id="element-297" data-mp="2kr0nw808y1ye" />
      <StatsBar data-id="element-298" data-mp="2knczfn9ns5qj" />
      <InfluencerCTA data-id="element-299" data-mp="3r61m6kcquw85" />
    </>;
}